import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../api/axiosInstance";

// Login API
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ WebEmail, WebPass }, { rejectWithValue }) => {
    try {
      /* console.log("Making login API call with:", { WebEmail, WebPass }); */
      const response = await axios.post("VMS_API_USER_LOGIN", {
        WebEmail,
        WebPass,
      });

      /* console.log("API Response:", response.data); */
      const data = response.data;

      if (data.API_CODE === 200 && data.UserInfo?.length > 0) {
        /* console.log("Login successful, user data:", data.UserInfo[0]); */
        return data.UserInfo[0];
      } else {
        console.log("Login failed:", data.API_MSG);
        return rejectWithValue(data.API_MSG || "Login failed");
      }
    } catch (error) {
      console.log("API Error:", error);
      console.log("Error response:", error.response?.data);
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Register API
export const registerUser = createAsyncThunk(
  "auth/registerUser",
  async ({ WebEmail, WebContact, WebPass }, { rejectWithValue }) => {
    try {
      const response = await axios.post("VMS_API_USER_REGISTER", {
        WebEmail,
        WebContact,
        WebPass,
      });

      const data = response.data;

      if (data.API_CODE === 200) {
        return data.API_MSG;
      } else {
        return rejectWithValue(data.API_MSG || "Registration failed");
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Initial State
const initialState = {
  user: JSON.parse(localStorage.getItem("user")) || null,
  loading: false,
  error: null,
  responseMsg: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.error = null;
      state.responseMsg = null;
      localStorage.removeItem("user");
    },
    clearAuthError: (state) => {
      state.error = null;
    },
    clearResponseMsg: (state) => {
      state.responseMsg = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Login
      .addCase(loginUser.pending, (state) => {
        /* console.log("Login pending - setting loading to true"); */
        state.loading = true;
        state.error = null;
        state.responseMsg = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        /* console.log("Login fulfilled - updating user state with:", action.payload); */
        state.loading = false;
        state.user = action.payload;
        localStorage.setItem("user", JSON.stringify(action.payload));
        /* console.log("Updated state:", state);
        console.log("State user after update:", state.user); */
      })
      .addCase(loginUser.rejected, (state, action) => {
        console.log("Login rejected - setting error:", action.payload);
        state.loading = false;
        state.error = action.payload;
        state.user = null;
      })

      // Register
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.responseMsg = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.responseMsg = action.payload;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.responseMsg = null;
      });
  },
});

export const { logout, clearAuthError, clearResponseMsg } = authSlice.actions;
export default authSlice.reducer;
